import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './layout';
import { Dashboard } from '../modules/dashboard/pages/Dashboard';
import { PessoaList } from '../modules/community/pages/PessoaList';
import { PessoaDetail } from '../modules/community/pages/PessoaDetail';
import { CalendarPage } from '../modules/calendar/pages/CalendarPage';
import { TaskList } from '../modules/tasks/pages/TaskList';
import { TaskDetail } from '../modules/tasks/pages/TaskDetail';
import { InventoryList } from '../modules/inventory/pages/InventoryList';
import { InventoryDetail } from '../modules/inventory/pages/InventoryDetail';
import { FinanceList } from '../modules/finance/pages/FinanceList';
import { FinanceDetail } from '../modules/finance/pages/FinanceDetail';
import { ObligationList } from '../modules/obligations/pages/ObligationList';
import { ObligationDetail } from '../modules/obligations/pages/ObligationDetail';
import { DocumentList } from '../modules/documents/pages/DocumentList';
import { DocumentDetail } from '../modules/documents/pages/DocumentDetail';
import { HouseSettings } from '../modules/house/pages/HouseSettings';
import { RolesList } from '../modules/roles/pages/RolesList';
import { RoleDetail } from '../modules/roles/pages/RoleDetail';
import { FunctionsList } from '../modules/functions/pages/FunctionsList';
import { FunctionDetail } from '../modules/functions/pages/FunctionDetail';
import { CommunicationUnavailable } from '../modules/communication/pages/CommunicationUnavailable';
import { CommunicationList } from '../modules/communication/pages/CommunicationList';
import { BillingPage } from '../modules/billing/pages/BillingPage';
import { LoginPage } from '../modules/auth/pages/LoginPage';
import { RequireSession } from '../modules/auth/RequireSession';
import { ActivatePage } from '../modules/auth/pages/ActivatePage';
import { HomeRedirect } from './home-redirect';
import { RequirePermission, AREA_PERMISSIONS } from '../platform/auth/permissions';
import type { ReactElement } from 'react';

function isCommunicationEnabled(): boolean {
  return false;
}

function guarded(area: string, element: ReactElement): ReactElement {
  const permission = AREA_PERMISSIONS[area];
  if (!permission) throw new Error(`Área sem permissão declarada: ${area}`);
  return <RequirePermission permission={permission}>{element}</RequirePermission>;
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/ativar', element: <ActivatePage /> },
  {
    path: '/',
    element: (
      <RequireSession>
        <Layout />
      </RequireSession>
    ),
    children: [
      { index: true, element: <HomeRedirect /> },
      { path: 'dashboard', element: guarded('/dashboard', <Dashboard />) },
      { path: 'pessoas', element: guarded('/pessoas', <PessoaList />) },
      { path: 'pessoas/:id', element: guarded('/pessoas', <PessoaDetail />) },
      { path: 'calendario', element: guarded('/calendario', <CalendarPage />) },
      { path: 'tarefas', element: guarded('/tarefas', <TaskList />) },
      { path: 'tarefas/:id', element: guarded('/tarefas', <TaskDetail />) },
      { path: 'estoque', element: guarded('/estoque', <InventoryList />) },
      { path: 'estoque/:id', element: guarded('/estoque', <InventoryDetail />) },
      { path: 'financeiro', element: guarded('/financeiro', <FinanceList />) },
      { path: 'financeiro/:id', element: guarded('/financeiro', <FinanceDetail />) },
      { path: 'obrigacoes', element: guarded('/obrigacoes', <ObligationList />) },
      { path: 'obrigacoes/:id', element: guarded('/obrigacoes', <ObligationDetail />) },
      { path: 'documentos', element: guarded('/documentos', <DocumentList />) },
      { path: 'documentos/:id', element: guarded('/documentos', <DocumentDetail />) },
      {
        path: 'comunicacao',
        element: isCommunicationEnabled() ? (
          guarded('/comunicacao', <CommunicationList />)
        ) : (
          <CommunicationUnavailable />
        ),
      },
      { path: 'configuracoes', element: guarded('/configuracoes', <HouseSettings />) },
      { path: 'assinatura', element: guarded('/assinatura', <BillingPage />) },
      { path: 'cargos', element: guarded('/cargos', <FunctionsList />) },
      { path: 'cargos/:id', element: guarded('/cargos', <FunctionDetail />) },
      { path: 'permissoes', element: guarded('/permissoes', <RolesList />) },
      { path: 'permissoes/:id', element: guarded('/permissoes', <RoleDetail />) },
    ],
  },
]);
